import LayoutHeaderNav from './components/layout-header-nav';
import Announcement from './components/announcement';
import Banner from './components/banner';
import VideoModal from './components/video-modal';
import TripleColSwiper from './components/triple-col-swiper';
import ProductSwiper from './components/product-swiper';
import TwinColSwiper from './components/twin-col-swiper';
import BannerSwiper from './components/banner-swiper';
import Timeline from './components/timeline';
import Accordion from './components/accordion';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import BannerSlider from './components/banner-slider';

export default () => {
  LayoutHeaderNav();

  Announcement();
  Banner();
  VideoModal();
  TripleColSwiper();
  ProductSwiper();
  TwinColSwiper();
  BannerSwiper();
  Timeline();
  Accordion();
  BannerSlider();
};
